var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCalendar = function SvgCalendar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.4H4M15.5556 4V7.2M8.44444 4V7.2M8.26667 20H15.7333C17.2268 20 17.9735 20 18.544 19.7384C19.0457 19.5083 19.4537 19.1412 19.7094 18.6896C20 18.1762 20 17.5041 20 16.16V9.44C20 8.09587 20 7.42381 19.7094 6.91042C19.4537 6.45883 19.0457 6.09168 18.544 5.86158C17.9735 5.6 17.2268 5.6 15.7333 5.6H8.26667C6.77319 5.6 6.02646 5.6 5.45603 5.86158C4.95426 6.09168 4.54631 6.45883 4.29065 6.91042C4 7.42381 4 8.09587 4 9.44V16.16C4 17.5041 4 18.1762 4.29065 18.6896C4.54631 19.1412 4.95426 19.5083 5.45603 19.7384C6.02646 20 6.77319 20 8.26667 20Z",
    stroke: "#5547DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "calendar.794a2ce6eab2345aab4f5ec19a0b6225.svg";